const DEFAULT_MAX_INITIALS = 2;

/**
 * Initials for an avatar placeholder.
 *
 * Unifies three copies that had drifted: the one in the profile avatar returned every
 * initial verbatim, while the top bar's uppercased them and capped the result at two. The
 * capped, uppercased version wins — a four-word name used to overflow the avatar circle.
 */
export const getInitials = (fullName: string, maxLength = DEFAULT_MAX_INITIALS): string => {
	if (!fullName) return '';

	return fullName
		.split(' ')
		.filter(Boolean)
		.map((part) => part.charAt(0).toUpperCase())
		.join('')
		.slice(0, maxLength);
};
